<template>
  <v-card
    outlined
    class="backoffice-table"
    style="box-shadow: none !important;"
  >
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      hide-default-footer
      @page-count="pageCount = $event"
      @update:page="requestPage($event)"
      class="elevation-1"
      :loading="loading"
      :mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <v-text-field
            class="search-feild"
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Pesquisar por"
            dense
            solo
            flat
            filled
            hide-details
          ></v-text-field>
          <!-- Create/Edit Dialog -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            content-class="backoffice-dialog"
            scrollable
          >
            <!-- Dialog Button -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                color="primary"
                height="40"
                v-bind="attrs"
                v-on="on"
                @click="
                  editedItem = Object.assign({}, emptyItem);
                  dialogTitle = 'Adicionar estatística';
                "
                >Adicionar estatística</v-btn
              >
            </template>
            <v-card>
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="dialog = false"
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-row style="overflow-y: auto;">
                <v-col cols="12" class="dialog-frame">
                  <div class="dialog-title">{{ dialogTitle }}</div>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Ano</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.year"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Tipo</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.label"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- JAN / FEB / MAR -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Janeiro</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[0].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Fevereiro</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[1].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Março</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[2].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- APR / MAY / JUN -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Abril</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[3].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Maio</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[4].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Junho</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[5].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- JUL / AGO / SEP -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Julho</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[6].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Agosto</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[7].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Setembro</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[8].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- OCT / NOV / DEC -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Outubro</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[9].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Novembro</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[10].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <div class="dialog-label">Dezembro</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        v-model="editedItem.data[11].y"
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="addItem()"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Data Header -->
      <template v-slot:[`header.data`]="{ header }">
        <div
          v-for="(headerItem, index) in header.text.split('|')"
          :key="'th-' + index"
          class="float-left"
          :style="'width: 56px;'"
        >
          {{ headerItem }}
        </div>
      </template>
      <template v-slot:[`item.data`]="{ item }">
        <div
          v-for="(data, index) in item.data"
          :key="'td-' + index"
          class="prognostic-div"
        >
          <div class="float-left" style="width: 56px">{{ data.y }}</div>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          dark
          color="#D8E0E6"
          class="gray-button"
          @click="editItem(item)"
          style="margin-right: 8px;"
          >Editar</v-btn
        >
        <RemoveItem
          :target="'resultado'"
          @remove-item="deleteItem(item)"
        ></RemoveItem>
      </template>
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - items.length" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
    <div class="pagination">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<style scoped>
@media only screen and (max-width: 1024px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 1180px;
  }
}
</style>

<script>
import Vue from "vue";
import RemoveItem from "@/components/RemoveItem";
import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "ResultsTable",
  components: {
    RemoveItem
  },
  props: { data: {} },
  data: () => ({
    dialog: false,
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    headers: [
      { text: "Ano", value: "year", sortable: false },
      { text: "Tipo", value: "label", sortable: false },
      {
        text: "Jan|Fev|Mar|Abr|Mai|Jun|Jul|Ago|Set|Out|Nov|Dez",
        value: "data",
        sortable: false
      },
      { text: "", align: "end", value: "actions", sortable: false }
    ],
    resultsTable: [
      {
        year: "2019",
        label: "Stake média",
        data: [
          {
            x: "Jan",
            y: 280.0
          },
          {
            x: "Fev",
            y: 384.0
          },
          {
            x: "Mar",
            y: 192.0
          },
          {
            x: "Abr",
            y: 344.0
          },
          {
            x: "Mai",
            y: 372.0
          },
          {
            x: "Jun",
            y: 252.0
          },
          {
            x: "Jul",
            y: 316.0
          },
          {
            x: "Ago",
            y: 160.0
          },
          {
            x: "Set",
            y: 216.0
          },
          {
            x: "Out",
            y: 344.0
          },
          {
            x: "Nov",
            y: 376.0
          },
          {
            x: "Dez",
            y: 428.0
          }
        ]
      }
    ],
    items: [],
    totalItems: 0,
    dialogTitle: "",
    editedItem: {
      id: "",
      year: "",
      label: "",
      data: [
        {
          x: "Jan",
          y: 0.0
        },
        {
          x: "Fev",
          y: 0.0
        },
        {
          x: "Mar",
          y: 0.0
        },
        {
          x: "Abr",
          y: 0.0
        },
        {
          x: "Mai",
          y: 0.0
        },
        {
          x: "Jun",
          y: 0.0
        },
        {
          x: "Jul",
          y: 0.0
        },
        {
          x: "Ago",
          y: 0.0
        },
        {
          x: "Set",
          y: 0.0
        },
        {
          x: "Out",
          y: 0.0
        },
        {
          x: "Nov",
          y: 0.0
        },
        {
          x: "Dez",
          y: 0.0
        }
      ]
    },
    emptyItem: {
      id: "",
      year: "",
      label: "",
      data: [
        {
          x: "Jan",
          y: 0.0
        },
        {
          x: "Fev",
          y: 0.0
        },
        {
          x: "Mar",
          y: 0.0
        },
        {
          x: "Abr",
          y: 0.0
        },
        {
          x: "Mai",
          y: 0.0
        },
        {
          x: "Jun",
          y: 0.0
        },
        {
          x: "Jul",
          y: 0.0
        },
        {
          x: "Ago",
          y: 0.0
        },
        {
          x: "Set",
          y: 0.0
        },
        {
          x: "Out",
          y: 0.0
        },
        {
          x: "Nov",
          y: 0.0
        },
        {
          x: "Dez",
          y: 0.0
        }
      ]
    }
  }),
  created() {
    this.getItems(0, this.itemsPerPage);
  },
  methods: {
    getItems(page, size) {
      this.loading = true;
      ApiService.getCharts(page, size).then(
        response => {
          this.items = response.data.charts;
          this.totalItems = response.data.totalElements;
          this.loading = false;
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    addItem() {
      this.loading = true;
      ApiService.saveChart(this.editedItem).then(
        response => {
          this.dialog = false;
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    editItem(item) {
      this.dialogTitle = "Editar resultado";
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.loading = true;
      ApiService.deleteChart(item.id).then(
        response => {
          console.log(response.data);
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    requestPage(page) {
      this.getItems(page - 1, this.itemsPerPage, this.search);
    }
  }
});
</script>